import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Box from '../Box';

var Header = function Header(_ref) {
  var css = _ref.css,
      restProps = _objectWithoutPropertiesLoose(_ref, ["css"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "rowgroup",
    flexShrink: 0,
    borderBottomWidth: 1,
    borderColor: "grey-3",
    position: "sticky",
    top: 0,
    zIndex: 15,
    overflow: "hidden",
    css: _objectSpread({
      '@media print': {
        overflow: 'visible',
        position: 'relative'
      }
    }, css)
  }, restProps));
};

export default Header;